import { apiRequest } from "../network/Api";


//States list api
export const getStateList = (path) => {
    return apiRequest({
      method: "GET",
      url: path,
    });
  };


//Cities list api
export const getCityList = (path) => {
    return apiRequest({
      method: "GET",
      url: path,
    });
  };

//Cities list api
export const getUserType = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
};

//disable the user
export const disableUser = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
};

// to get the userdetails
export const UserDetails = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
};


// to get the serviceList of the api
export const servicesList = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
};

// to get the serviceList of the api
export const storeDetailedView = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
};

export const getStoreAmenities = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}

export const getShareDetials = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}

export const ShareValueDetials = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}


export const orderNewRequest = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}

export const FaqList = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}

export const getPromoCode = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}

export const getStoreDetails = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}

export const getDashBoardDetails = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}

export const getNotificationDetails = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}

export const getMasterData = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}
export const getHomeData = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}
export const getSeoData = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}
export const getSupportDetails = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}
export const getSharesList = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}

export const getBankList = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}
export const getVerificationStatus = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}
export const getVerificationOTP = (path) => {
  return apiRequest({
    method: "GET",
    url: path,
  });
}